import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/helpers';

export const REPORT_INCIDENT_ROUTES: Routes = [
  {
    path: 'ReportStudentIncident',
    loadComponent: () =>
      import('./report-student-incident/report-student-incident.component').then(
        m => m.ReportStudentIncidentComponent,
      ),
    canActivate: [AuthGuard],
  },
];
